import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';
import './weconnect.css';
let data = require('./lang/lang.json');

function Lab() {
  const text = data[localStorage.getItem('language')];
  // newest first — keep this array ordered by year, descending
  const programs = [
    {
      title: text.lab_camps_title,
      desc: text.lab_camps_desc,
      image: 'lab-item4.png',
    },
    {
      title: text.lab_crafts_title,
      desc: text.lab_crafts_desc,
      image: 'lab-item5.png',
    },
    {
      title: text.lab_parunakum_title,
      desc: text.lab_parunakum_desc,
      image: 'lab-item3.png',
    },
    {
      title: text.lab_ad_club_title,
      desc: text.lab_ad_club_desc,
      image: 'lab-item1.jpeg',
      extra: (
        <div className='row sml-block'>
          <a href='/masterOhan' className='col-lg-7 mobile-pb'>
            <div className='lab-details lab-mobile-details'>
              <img src='images/master-ogan.jpeg' alt='' />
              <div>
                <p className='m-0' dangerouslySetInnerHTML={{ __html: '«' + text.mo_title + '»' }}></p>
                <p dangerouslySetInnerHTML={{ __html: text.mo_author }}></p>
              </div>
            </div>
          </a>
        </div>
      ),
    },
    {
      title: text.lab_tech_amateur_title,
      desc: text.lab_tech_amateur_desc,
      image: 'lab-item2.jpeg',
      extra: (
        <div className='row sml-block lab-mobile-details'>
          <a href='/line' className='col-lg-5'>
            <p className='mb-0'>{text.line} 2017</p>
            <p dangerouslySetInnerHTML={{ __html: text.line_author }}></p>
            <img src='images/slider-item4.jpg' alt='' />
          </a>
          <div className='col-lg-1'></div>
          <a href='/maro2' className='col-lg-5'>
            <p className='mb-0'>{text.maro} 2013 </p>
            <p dangerouslySetInnerHTML={{ __html: text.mo_author }}></p>
            <img src='images/slider-item6.jpg' alt='' />
          </a>
        </div>
      ),
    },
  ];
  return (
    <section className='main-container'>
      <div className='description-banner'>
        <h2 className='title-generic text-uppercase'>{text.lab}</h2>
        <p dangerouslySetInnerHTML={{ __html: text.lab_desc }}></p>
      </div>

      <section className='center-slider  lab-container'>
        {programs.map(({ title, desc, image, extra }, index) => {
          // alternate the image between the left and the right column
          const imageFirst = index % 2 === 0;
          const picture = (
            <div className='col-lg-6'>
              <img src={`../images/lab/${image}`} alt='icon' className='img-fluid img-box' />
            </div>
          );
          const description = (
            <div className='col-lg-6'>
              <p className='row m-0'>{title}</p>
              <p dangerouslySetInnerHTML={{ __html: desc }}></p>
              {extra}
            </div>
          );
          return (
            <div key={image}>
              <div className='generic-container'>
                <div className={`row m-0 ${imageFirst ? '' : 'flex-reverse'}`}>
                  {imageFirst ? picture : description}
                  {imageFirst ? description : picture}
                </div>
              </div>
              {index < programs.length - 1 && (
                <div className='col-12'>
                  <img src='images/we-read/line1.svg' className='img-fluid' alt='item' title='item' />
                </div>
              )}
            </div>
          );
        })}
      </section>
    </section>
  );
}
const mapDispatchToProps = (dispatch) => ({
  setLanguage: (language) => dispatch({ type: 'SET_LANGUAGE', language }),
});

const mapStateToProps = (state) => {
  return { language: state.language };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Lab));
